/**
 * Phase 16a (ADR-0023): the bireysel edition's words, kept apart from tr.ts and en.ts (merged in index.ts under
 * `b2cPlatform`). Turkish first; the English mirrors it key for key.
 *
 * Platform › Kullanıcılar, Paketler and Kapasite (B2cPlatformPaketler, B2cPlatformKapasite). Part 1 has no
 * subscriptions: the plans count "kişi", not "abone", and the intro leaves out payments.
 */
export const b2cPlatformTr = {
  b2cPlatform: {
    intro: 'Bireysel kurulumun modelleri, kullanıcıları, paketleri ve kapasitesi.',
    tabs: { users: 'Kullanıcılar', plans: 'Paketler' },
    planNames: { free: 'Ücretsiz', pro: 'Pro' },
    plans: {
      note: "Ücretsiz'in sınırları daralırsa değişiklik 7 gün sonra yürürlüğe girer; Ücretsiz kullanıcılara e-postayla duyurulur. Daha geniş sınırlar ve Pro'nun değerleri hemen geçerlidir; abonelikler açılınca Pro'daki değişiklikler 30 gün önce duyurulacak.",
      save: 'Değişiklikleri kaydet',
      status: { free: 'Kayıtta verilir', onSale: 'Satışta', notOnSale: 'Satışta değil' },
      people_one: '{{value}} kişi',
      people_other: '{{value}} kişi',
      fields: {
        monthlyPriceKurus: 'Aylık fiyat (KDV dahil)',
        yearlyPriceKurus: 'Yıllık fiyat (KDV dahil)',
        dailyTokens: 'Günlük token',
        maxDocuments: 'Belge sayısı',
        maxFileMb: 'Dosya boyutu',
      },
      lira: 'TL',
      megabytes: 'MB',
      vat: 'KDV dahil: {{net}} + {{vat}}',
      noYearly: 'Boş bırakılırsa yıllık seçenek sunulmaz.',
      ownConnections: { title: 'Kendi bağlantıları (MCP)', hint: 'Kişi kendi MCP sunucusunu ekleyebilir', label: 'Kendi bağlantıları, {{plan}}' },
      errors: {
        required: 'Bir değer yazın.',
        price: 'Tutarı 500,00 gibi yazın.',
        min: 'En az {{value}} olabilir.',
        max: 'En çok {{value}} olabilir.',
        invalid: 'Bu değer kullanılamaz.',
      },
      pending: {
        title: '{{date}} tarihinde yürürlüğe girecek:',
        on: 'var',
        off: 'yok',
        noticesDone_one: '{{value}} kişiye e-posta gitti',
        noticesDone_other: '{{value}} kişiye e-posta gitti',
        noticesSending_one: 'e-postalar gidiyor, şimdiye kadar {{value}} kişiye gitti',
        noticesSending_other: 'e-postalar gidiyor, şimdiye kadar {{value}} kişiye gitti',
        cancel: 'Vazgeç',
        cancelled: 'Duyurulan değişiklikten vazgeçildi; sınırlar olduğu gibi kalır. Gönderilen e-postalar geri alınamaz.',
      },
      saved: {
        title: 'Kaydedildi',
        now: '{{plan}}: yeni değerler hemen geçerli.',
        scheduled: '{{plan}}: 7 gün sonra yürürlüğe girecek; Ücretsiz kullanıcılara e-posta gidiyor.',
        unchanged: '{{plan}}: değişiklik yoktu.',
      },
    },
    users: {
      label: 'Kullanıcılar',
      search: 'Kişi ya da e-posta',
      noun: 'kişi',
      empty: 'Henüz kimse kaydolmadı.',
      noMatch: 'Aramaya uyan kimse yok.',
      columns: { person: 'Kişi', plan: 'Paket', createdAt: 'Kayıt', today: 'Bugün', documents: 'Belgeler' },
      unverified: 'doğrulanmadı',
      internal: 'iç ağ açık',
      proUntil: 'Pro · {{day}} kadar',
      menu: {
        label: '{{name}} için işlemler',
        grant: 'Pro ver',
        revoke: "Pro'yu geri al",
        allowInternal: 'İç ağ adreslerine izin ver',
        blockInternal: 'İç ağ adreslerini kapat',
      },
      reason: 'Neden',
      reasonHint: 'Denetim kaydına yazılır; kişiye gösterilmez.',
      reasonShort: 'En az 3 karakter yazın.',
      grant: {
        title: 'Pro ver',
        body: "Kişi son günün sonuna kadar Pro'da kalır, sonra kendiliğinden Ücretsiz'e döner. Kişiye e-postayla haber verilir.",
        replaces: "Şu anki Pro'su {{day}} kadar; yeni son gün onun yerine geçer.",
        until: 'Son gün',
        untilHint: 'Bugünden en geç {{last}} gününe kadar.',
        untilInvalid: 'Bugün ile {{last}} arasında bir gün seçin.',
        submit: 'Pro ver',
        done: "{{name}} {{day}} kadar Pro'da. Kişiye e-postayla haber verildi.",
      },
      revoke: {
        title: "Pro'yu geri al",
        body: "Kişi hemen Ücretsiz'e döner; belgeleri ve bağlantıları silinmez. Kişiye e-postayla haber verilir.",
        submit: "Pro'yu geri al",
        done: "{{name}} Ücretsiz'e döndü.",
      },
      internalDone: { on: '{{name}} artık iç ağ adreslerini kullanabilir.', off: '{{name}} için iç ağ adresleri kapatıldı.' },
    },
    capacity: {
      server: {
        title: 'Model sunucusu',
        status: { up: 'Çalışıyor', down: 'Ulaşılamıyor', unknown: 'Bilinmiyor' },
        shared: 'kurumsal kurulumla ortak',
        named: '{{name}} · kurumsal kurulumla ortak',
      },
      requests: { title: 'Bireysel istekler, şu an', max: 'aynı anda en çok {{max}}', busy: 'sunucu yoğun, şu an en çok {{limit}}' },
      queue: {
        title: 'Sırada',
        none: 'sıra yok',
        allFree: 'hepsi Ücretsiz',
        allPro: 'hepsi Pro',
        mixed: '{{pro}} Pro, {{free}} Ücretsiz',
        wait: 'en uzun bekleyen {{seconds}} sn',
      },
      tokens: { title: 'Bugün işlenen', unit: 'token', shares: 'token · Pro {{pro}}, Ücretsiz {{free}}' },
      share: {
        title: 'Paylaşım ve sıra',
        max: {
          title: 'Bireysel kullanıma ayrılan pay',
          hint: 'Aynı anda en çok bu kadar bireysel istek modele gider. Fazlası sıraya girer; kurumsal kullanıcılar etkilenmez.',
          unit: 'istek',
          invalid: '1 ile 500 arasında bir sayı yazın.',
        },
        order: {
          title: 'Sıra',
          options: { pro_first: 'Pro önce, Ücretsiz sonra', arrival: 'Geliş sırasıyla' },
          hints: {
            pro_first: 'Sıra oluşursa Pro kullanıcılarının soruları önce yanıtlanır. Kullanıcılara duyurulmaz.',
            arrival: 'Sıra oluşursa sorular paketten bağımsız, geliş sırasıyla yanıtlanır. Kullanıcılara duyurulmaz.',
          },
        },
        shown: {
          title: 'Kullanıcıya gösterilen',
          hint: 'Sırada bekleyen kişi yalnız olağan “yanıt hazırlanıyor” simgesini görür; yoğunluk ya da sıra yazısı çıkmaz.',
          value: 'Bilgi yok, yalnız bekleme',
        },
      },
      mail: {
        title: 'E-posta gönderimi',
        none: 'Henüz e-posta gönderilmedi',
        working: 'Çalışıyor · son gönderim {{when}}',
        failing: 'Gönderilemiyor · {{kind}} · son deneme {{when}}',
        failures_one: 'Son deneme başarısız oldu.',
        failures_other: 'Art arda {{count}} deneme başarısız oldu.',
        lastSuccess: 'Son başarılı gönderim {{when}}.',
        errorLabel: 'Son hatanın metni',
        kinds: {
          auth: "Kimlik doğrulaması reddedildi (şifre yanlış ya da Microsoft 365'te SMTP AUTH kapalı)",
          connection: 'Sunucuya bağlanılamadı',
          timeout: 'Zaman aşımı',
          tls: 'Şifreli bağlantı kurulamadı',
          rejected: 'Gönderim reddedildi',
          other: 'Bilinmeyen hata',
        },
      },
      fairUse: {
        title: 'Adil kullanım · bugün en çok kullananlar',
        note: 'günlük sınıra göre',
        columns: { person: 'Kişi', plan: 'Paket', today: 'Bugün', avg7: 'Son 7 gün ortalaması', status: 'Durum', action: 'İşlem' },
        share: 'Günlük sınırın {{percent}} kadarı',
        near_one: '{{count}} gündür sınıra yakın',
        near_other: '{{count}} gündür sınıra yakın',
        usedUp: 'Bugünkü hakkı doldu',
        mail: 'Adil kullanım e-postası',
        sent: 'E-posta gönderildi · {{when}}',
        empty: 'Bugün henüz kullanım yok.',
        footnote: 'Art arda 3 gün günlük sınırının %80’ini aşanlar işaretlenir. Otomatik bir şey yapılmaz; kullanım koşullarındaki adil kullanım maddesine göre siz karar verirsiniz.',
        dialog: {
          title: 'Adil kullanım e-postası',
          intro: 'E-posta şablondan hazırlandı. Göndermeden önce okuyun; gönderim denetim kaydına yazılır.',
          to: 'Kime',
          subject: 'Konu',
          text: 'Metin',
          loading: 'E-posta hazırlanıyor',
          send: 'Gönder',
        },
        done: '{{name}} için adil kullanım e-postası gönderildi.',
      },
    },
  },
};

export const b2cPlatformEn: typeof b2cPlatformTr = {
  b2cPlatform: {
    intro: "The personal installation's models, users, plans and capacity.",
    tabs: { users: 'Users', plans: 'Plans' },
    planNames: { free: 'Free', pro: 'Pro' },
    plans: {
      note: "When Free's limits get stricter, the change takes effect after 7 days and Free users are told by e-mail. More generous limits and Pro's values apply at once; once subscriptions open, changes to Pro will be announced 30 days ahead.",
      save: 'Save changes',
      status: { free: 'Given at sign-up', onSale: 'On sale', notOnSale: 'Not on sale' },
      people_one: '{{value}} person',
      people_other: '{{value}} people',
      fields: {
        monthlyPriceKurus: 'Monthly price (VAT included)',
        yearlyPriceKurus: 'Yearly price (VAT included)',
        dailyTokens: 'Daily tokens',
        maxDocuments: 'Documents',
        maxFileMb: 'File size',
      },
      lira: 'TL',
      megabytes: 'MB',
      vat: 'VAT included: {{net}} + {{vat}}',
      noYearly: 'Left empty, there is no yearly option.',
      ownConnections: { title: 'Own connections (MCP)', hint: 'The person can add their own MCP server', label: 'Own connections, {{plan}}' },
      errors: {
        required: 'Enter a value.',
        price: 'Write the amount like 500.00.',
        min: 'It can be {{value}} at least.',
        max: 'It can be {{value}} at most.',
        invalid: 'This value cannot be used.',
      },
      pending: {
        title: 'Takes effect on {{date}}:',
        on: 'on',
        off: 'off',
        noticesDone_one: 'e-mail sent to {{value}} person',
        noticesDone_other: 'e-mail sent to {{value}} people',
        noticesSending_one: 'e-mails going out, {{value}} person so far',
        noticesSending_other: 'e-mails going out, {{value}} people so far',
        cancel: 'Cancel',
        cancelled: 'The announced change is cancelled; the limits stay as they are. E-mails already sent cannot be taken back.',
      },
      saved: {
        title: 'Saved',
        now: '{{plan}}: the new values apply at once.',
        scheduled: '{{plan}}: takes effect in 7 days; Free users are being e-mailed.',
        unchanged: '{{plan}}: nothing had changed.',
      },
    },
    users: {
      label: 'Users',
      search: 'Person or e-mail',
      noun: 'people',
      empty: 'Nobody has signed up yet.',
      noMatch: 'Nobody matches the search.',
      columns: { person: 'Person', plan: 'Plan', createdAt: 'Signed up', today: 'Today', documents: 'Documents' },
      unverified: 'not verified',
      internal: 'internal network on',
      proUntil: 'Pro · until {{day}}',
      menu: {
        label: 'Actions for {{name}}',
        grant: 'Give Pro',
        revoke: 'Take Pro back',
        allowInternal: 'Allow internal network addresses',
        blockInternal: 'Turn internal network addresses off',
      },
      reason: 'Reason',
      reasonHint: 'Written to the audit log; not shown to the person.',
      reasonShort: 'Write at least 3 characters.',
      grant: {
        title: 'Give Pro',
        body: 'The person stays on Pro until the end of the last day, then goes back to Free by itself. They are told by e-mail.',
        replaces: 'Their Pro now runs until {{day}}; the new last day takes its place.',
        until: 'Last day',
        untilHint: 'From today to {{last}} at the latest.',
        untilInvalid: 'Choose a day from today to {{last}}.',
        submit: 'Give Pro',
        done: '{{name}} is on Pro until {{day}}. They were told by e-mail.',
      },
      revoke: {
        title: 'Take Pro back',
        body: 'The person goes back to Free at once; their documents and connections are not deleted. They are told by e-mail.',
        submit: 'Take Pro back',
        done: '{{name}} is back on Free.',
      },
      internalDone: { on: '{{name}} can now use internal network addresses.', off: 'Internal network addresses are turned off for {{name}}.' },
    },
    capacity: {
      server: {
        title: 'Model server',
        status: { up: 'Running', down: 'Unreachable', unknown: 'Unknown' },
        shared: 'shared with the company installation',
        named: '{{name}} · shared with the company installation',
      },
      requests: { title: 'Personal requests now', max: 'at most {{max}} at a time', busy: 'server busy, at most {{limit}} now' },
      queue: {
        title: 'Waiting',
        none: 'no queue',
        allFree: 'all Free',
        allPro: 'all Pro',
        mixed: '{{pro}} Pro, {{free}} Free',
        wait: 'longest wait {{seconds}} s',
      },
      tokens: { title: 'Processed today', unit: 'tokens', shares: 'tokens · Pro {{pro}}, Free {{free}}' },
      share: {
        title: 'Share and queue',
        max: {
          title: 'Share for personal use',
          hint: 'At most this many personal requests go to the model at a time. The rest wait in the queue; company users are not affected.',
          unit: 'requests',
          invalid: 'Enter a number from 1 to 500.',
        },
        order: {
          title: 'Queue',
          options: { pro_first: 'Pro first, then Free', arrival: 'In order of arrival' },
          hints: {
            pro_first: 'When a queue forms, Pro users’ questions are answered first. Users are not told.',
            arrival: 'When a queue forms, questions are answered in order of arrival, whatever the plan. Users are not told.',
          },
        },
        shown: {
          title: 'What users see',
          hint: 'A person waiting in the queue sees only the usual “preparing an answer” sign; no word of load or queue.',
          value: 'Nothing, only the wait',
        },
      },
      mail: {
        title: 'E-mail sending',
        none: 'No e-mail sent yet',
        working: 'Working · last sent {{when}}',
        failing: 'Cannot send · {{kind}} · last try {{when}}',
        failures_one: 'The last try failed.',
        failures_other: '{{count}} tries in a row failed.',
        lastSuccess: 'Last sent successfully {{when}}.',
        errorLabel: "The last error's text",
        kinds: {
          auth: 'Authentication refused (wrong password, or SMTP AUTH is off in Microsoft 365)',
          connection: 'Could not connect to the server',
          timeout: 'Timed out',
          tls: 'Could not set up an encrypted connection',
          rejected: 'Sending refused',
          other: 'Unknown error',
        },
      },
      fairUse: {
        title: 'Fair use · top users today',
        note: 'against the daily limit',
        columns: { person: 'Person', plan: 'Plan', today: 'Today', avg7: 'Last 7 days average', status: 'Status', action: 'Action' },
        share: '{{percent}} of the daily limit',
        near_one: 'near the limit for {{count}} day',
        near_other: 'near the limit for {{count}} days',
        usedUp: "Today's allowance used up",
        mail: 'Fair use e-mail',
        sent: 'E-mail sent · {{when}}',
        empty: 'No use yet today.',
        footnote: 'People over 80% of their daily limit 3 days in a row are flagged. Nothing happens automatically; you decide under the fair use clause of the terms of use.',
        dialog: {
          title: 'Fair use e-mail',
          intro: 'The e-mail is made from the template. Read it before sending; sending is written to the audit log.',
          to: 'To',
          subject: 'Subject',
          text: 'Text',
          loading: 'Preparing the e-mail',
          send: 'Send',
        },
        done: 'Fair use e-mail sent to {{name}}.',
      },
    },
  },
};
